export var CalendarCellAlignment;
(function (CalendarCellAlignment) {
    CalendarCellAlignment["left"] = "left";
    CalendarCellAlignment["center"] = "center";
    CalendarCellAlignment["right"] = "right";
})(CalendarCellAlignment || (CalendarCellAlignment = {}));
export var CalendarCellTimes;
(function (CalendarCellTimes) {
    CalendarCellTimes["pastDate"] = "pastDate";
    CalendarCellTimes["today"] = "today";
    CalendarCellTimes["futureDate"] = "futureDate";
})(CalendarCellTimes || (CalendarCellTimes = {}));
export var CalendarCellDataKeys;
(function (CalendarCellDataKeys) {
    CalendarCellDataKeys["Stertchable"] = "data-stretchable";
    CalendarCellDataKeys["TimeType"] = "data-time-type";
    CalendarCellDataKeys["Current"] = "data-current";
    CalendarCellDataKeys["Alignment"] = "data-alignment";
})(CalendarCellDataKeys || (CalendarCellDataKeys = {}));
//# sourceMappingURL=types.js.map